import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconDataWaterfall$1 = /*@__PURE__*/ proxyCustomElement(class WppIconDataWaterfall extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-data-waterfall", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M1 2.675C1 2.30221 1.30221 2 1.675 2H7.525C8.64338 2 9.55 2.90662 9.55 4.025V9.2H15.175C16.2934 9.2 17.2 10.1066 17.2 11.225V16.85H18.325C18.6978 16.85 19 17.1522 19 17.525C19 17.8978 18.6978 18.2 18.325 18.2H12.475C11.3566 18.2 10.45 17.2934 10.45 16.175V10.55H4.825C3.70662 10.55 2.8 9.64338 2.8 8.525V3.35H1.675C1.30221 3.35 1 3.04779 1 2.675ZM15.85 16.85V11.225C15.85 10.8522 15.5478 10.55 15.175 10.55H11.8V16.175C11.8 16.5478 12.1022 16.85 12.475 16.85H15.85ZM8.2 4.025C8.2 3.65221 7.89779 3.35 7.525 3.35H4.15V8.525C4.15 8.89779 4.45221 9.2 4.825 9.2H8.2V4.025Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-data-waterfall-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-data-waterfall", "wpp-icon-data-waterfall-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-data-waterfall-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-data-waterfall-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconDataWaterfall$1);
      }
      break;
  } });
}

const WppIconDataWaterfall = WppIconDataWaterfall$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconDataWaterfall, defineCustomElement };
